import { useEffect } from "react";
import { useAppSelector } from "../../../redux/hooks";
import { getLiveAndVodDetails } from "../../../redux/actions/videoData.actions";
import { conditions } from "../../conditions/conditions";
import { ConditionName } from "../../../interfaces/enums";
import { livePlayRetryDuration } from "../../environment";
import { shallowEqual } from "react-redux";

const useGetDetails = () => {
    const { params, token, isLiveError } = useAppSelector(
        ({ videoData: { params, token, isLiveError } }) => ({ params, token, isLiveError }),
        shallowEqual
    );
    useAppSelector(({ controller: { isEnded } }) => ({ isEnded }), shallowEqual);

    useEffect(() => {
        if (conditions(ConditionName.getDetails)) getLiveAndVodDetails();
    }, [params.id, params.type]);

    useEffect(() => {
        let interval: any;
        if (conditions(ConditionName.getLiveDetailsInIntervals) && !conditions(ConditionName.isEnded))
            interval = setInterval(() => getLiveAndVodDetails(), livePlayRetryDuration);
        else clearInterval(interval);

        return () => clearInterval(interval);
    }, [isLiveError, token]);
};

export default useGetDetails;
